module.exports = __webpack_public_path__ + "static/media/temp-w-domu-chlodzenie.14bde54c.svg";